import { get } from '../api.service';

// TypeScript interfaces for invoice summary
export interface InvoiceSummaryResponse {
  statusCode: number;
  message: string;
  response: {
    totalInvoiceAmount: number;
    paidInvoicesAmount: number;
    overdueInvoicesAmount: number;
  };
  totalCount: number;
}

/**
 * Fetch invoice amount summary
 * GET /api/userdashboard/invoice-amount-summary
 */
export const fetchInvoiceSummary = async (): Promise<InvoiceSummaryResponse> => {
  try {
    const response = await get('userdashboard/invoice-amount-summary');
    return response;
  } catch (error) {
    console.error('Error fetching invoice summary:', error);
    throw error;
  }
};